var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9259899E-C97D-43F6-87F4-6F587542F285") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Guidemark-Admin-Desktop-Schedule-time-view-2",
    transform: "translate(-856.000000, -608.000000)",
    fill: "#DD6060",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schedule-/-Admin-/-Time-view-Copy-3",
    transform: "translate(770.000000, 451.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(66.000000, 157.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Canceled-/-Red",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8977572,0 C6.23466649,0 0,6.23424224 0,13.8977572 C0,21.5612721 6.23424224,27.7955143 13.8977572,27.7955143 C21.5612721,27.7955143 27.7955143,21.5612721 27.7955143,13.8977572 C27.7955143,6.23424224 21.5608479,0 13.8977572,0 Z M2.54545462,13.8977573 C2.54545462,7.63806054 7.63806054,2.54545462 13.8977573,2.54545462 C16.7181209,2.54545462 19.3000602,3.58187884 21.2876359,5.29115152 L5.29115152,21.2876359 C3.58187884,19.3000602 2.54545462,16.7181209 2.54545462,13.8977573 Z M13.8977578,25.2500606 C11.3743638,25.2500606 9.04145474,24.4215151 7.15442443,23.0236363 L23.0232124,7.15484834 C24.4210912,9.04187865 25.2496367,11.3747878 25.2496367,13.8981817 C25.2500609,20.1574545 20.1574548,25.2500606 13.8977578,25.2500606 Z",
    id: "Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.03baebd0ec005b3f635444c3a4ff2c16.svg";
export { ForwardRef as ReactComponent };